import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import Navbar from './Navbar';
import Footer from './Footer';

function ContactForm() {
  const [state, handleSubmit] = useForm("xqabwqdn");

  if (state.succeeded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f1f4ec] text-[#1A3C34] font-sans px-6">
        <div className="bg-white shadow-xl rounded-xl max-w-md w-full p-8 text-center">
          <h2 className="text-2xl font-bold italic mb-4">Thank you!</h2>
          <p className="text-gray-700">
            Your message has been received. I’ll be in touch soon to explore how we can work together on your wellness journey.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white text-[#1A3C34] font-sans">
      <Navbar />

      <section className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-8 text-center">
          Let’s <span className="italic text-[#F9C93F]">Connect</span>
        </h1>
        <p className="text-lg text-gray-700 leading-relaxed text-center mb-12 max-w-xl mx-auto">
          Interested in working together or have a question about my programs? Use the form below to reach out. I’d love to hear more about your vision for wellness.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium mb-1 italic text-[#1A3C34]">
              Your Name
            </label>
            <input
              id="name"
              type="text"
              name="name"
              required
              className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#F9C93F] focus:outline-none"
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" className="block text-sm font-medium mb-1 italic text-[#1A3C34]">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              name="email"
              required
              className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#F9C93F] focus:outline-none"
            />
            <ValidationError prefix="Email" field="email" errors={state.errors} />
          </div>

          {/* Service */}
          <div>
            <label htmlFor="service" className="block text-sm font-medium mb-1 italic text-[#1A3C34]">
              I'm interested in...
            </label>
            <select
              id="service"
              name="service"
              required
              className="w-full px-4 py-3 rounded-md border border-gray-300 bg-white text-[#1A3C34] focus:ring-2 focus:ring-[#F9C93F] focus:outline-none"
            >
              <option value="">Select a Service</option>
              <option value="Wellness Coaching">1:1 Wellness Coaching</option>
              <option value="Group Program">Group Program / Workshop</option>
              <option value="Custom Wellness Support">Custom Wellness Support</option>
            </select>
            <ValidationError prefix="Service" field="service" errors={state.errors} />
          </div>

          {/* Project Brief */}
          <div>
            <label htmlFor="brief" className="block text-sm font-medium mb-1 italic text-[#1A3C34]">
              Tell Me a Bit About Your Wellness Goals
            </label>
            <textarea
              id="brief"
              name="brief"
              rows="5"
              required
              className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#F9C93F] focus:outline-none"
            ></textarea>
            <ValidationError prefix="Brief" field="brief" errors={state.errors} />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={state.submitting}
            className="bg-[#F9C93F] text-black font-semibold px-6 py-3 rounded-full border border-black hover:bg-black hover:text-white transition-colors duration-300"
          >
            Send My Message
          </button>
        </form>
      </section>

      <Footer />
    </div>
  );
}

export default ContactForm;
